import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import * as actionCreator from '../actions/actions';
import EntryPopup from "./popup/SmartHouseEntryPopup";
import DoorLogPopup from "./popup/SmartHouseDoorLogPopup";
import { withFirebaseAuth } from '../auth/withFirebaseAuth';
import * as moment from 'moment';
import Toggle from 'react-toggle';
import ConfirmPopup from './popup/ConfirmPopup';
import './css/SmartHouseAdmin.css';

interface Props {
    firebaseAuth: any;
    
    navigation: any;

    auth?: any;
    flatList: Array<any>;
    entryList: Array<any>;
    getFlatList(token: any): void;
    getEntryList(token: any): void;
    deleteEntry(token: any, selectedEntry: any): void;
}

interface State {
    selectedEntry: any,
    selectedFlat: any,
    showPopupEntry: boolean,
    showPopupDoorLog: boolean,
    token: any,
    popupTitle: string,
    isTrackerNotSaved: boolean;
    errorMessage: string;
    isUserSaved: boolean;
    isUserUpdated: boolean;
    tokenUser: any,
    isSaved: boolean;
    isDeleted: boolean;
    showConfirmPopup: boolean;
}

const mapStateToProps = (state: any) => {
    return {
        flatList: state.flatList,
        entryList: state.entryList,
        isSaved: state.isFlatKeySaved,
        isDeleted: state.isDeleted,
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        getFlatList: () => dispatch<any>(actionCreator.default.smartHouse.getFlatList()), //no tocken for this one because we use it unlogged
        getEntryList: (token: any) => dispatch<any>(actionCreator.default.smartHouse.getEntryList(token)),
        deleteEntry: (token: any, selectedEntry: any) => dispatch<any>(actionCreator.default.smartHouse.deleteEntry(token, selectedEntry)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFirebaseAuth(class SmartHouseAdmin extends React.Component<Props, State> {
    static displayName = SmartHouseAdmin.name;
    constructor(props: any) {
        super(props);

        this.state = {
            showPopupEntry: false,
            showPopupDoorLog: false,
            selectedFlat: {},
            token: null,
            tokenUser: null,
            popupTitle: "",
            selectedEntry: {},
            isTrackerNotSaved: false,
            errorMessage: "",
            isUserSaved: false,
            isUserUpdated: false,
            isSaved: false,
            isDeleted: false,
            showConfirmPopup: false
        };
    };

    async componentDidMount() {
        try {
            const token = await this.props.firebaseAuth.getAccessToken();
            if (token) {
                this.props.getFlatList(token);
                this.props.getEntryList(token);
                this.setState({
                    token: token
                })
            }
        } catch (err) {
            console.error("Error getting token:", err);
        }
    }

    handleAddEntry = () => {
        this.setState({
            popupTitle: "New Entry",
            selectedEntry: {
                entryId: 0,
                entryName: '',
                entryCheckIn: '',
                entryCheckOut: '',
                entryCode: '',
                isDoorCodeValid: true
            },
            showPopupEntry: true
        });
    }

    handleEditEntry = (entry: any) => {
        this.setState({
            popupTitle: "Edit Entry",
            selectedEntry: entry,
            showPopupEntry: true
        });
    }

    handleDeleteEntry = (entry: any) => {
        this.setState({
            selectedEntry: entry,
            showConfirmPopup: true
        });
    }

    handleConfirmDelete = (confirmDelete: boolean) => {
        if (confirmDelete) {
            this.setState({ showConfirmPopup: false });
            this.props.deleteEntry(this.state.token, this.state.selectedEntry);
        }
        else {
            this.setState({
                showConfirmPopup: false,
            });
        }
    }

    handleCloseEntryPopup = (data: string) => {
        this.setState({
            showPopupEntry: false,
        });
    }

    handleShowDoorLogs = (flat: any) => {
        this.setState({
            selectedFlat: flat,
            showPopupDoorLog: true
        });
    }

    handleCloseDoorLogPopup = (data: string) => {
        this.setState({
            showPopupDoorLog: false,
        });
    }

    render() {

        let displayEntryList = this.props.entryList.map((item, index) => (
            <tr key={index} className="table-row">
                <td className="name-cell">
                    <div className="user-info">
                        <i className="fas fa-user-circle me-2 text-primary"></i>
                        <span className="fw-medium">{item.entryName}</span>
                    </div>
                </td>
                <td className="flat-cell">
                    <span className="badge bg-light text-dark">
                        {item.flat?.flatName || "N/A"}
                    </span>
                </td>
                <td className="date-cell">
                    <span className="date-text">
                        {item.entryCheckIn ? moment.parseZone(item.entryCheckIn).format('DD/MM/YYYY HH:mm') : "N/A"}
                    </span>
                </td>
                <td className="date-cell">
                    <span className="date-text">
                        {item.entryCheckOut ? moment.parseZone(item.entryCheckOut).format('DD/MM/YYYY HH:mm') : "N/A"}
                    </span>
                </td>
                <td className="code-cell">
                    <code className="entry-code">
                        {item.entryCode || "N/A"}
                    </code>
                </td>
                <td className="actions-cell">
                    <div className="btn-group btn-group-sm" role="group">
                        <button 
                            className="btn btn-outline-primary"
                            onClick={() => this.handleEditEntry(item)}
                            title="Edit entry"
                        >
                            <i className="fas fa-edit"></i>
                        </button>
                        <button 
                            className="btn btn-outline-danger"
                            onClick={() => this.handleDeleteEntry(item)}
                            title="Delete entry"
                        >
                            <i className="fas fa-trash"></i>
                        </button>
                    </div>
                </td>
            </tr>
        ));

        let displayFlatList = this.props.flatList.map((item, index) => (
            <tr key={index} className="table-row">
                <td className="flat-name-cell">
                    <div className="flat-info">
                        <i className="fas fa-home me-2 text-success"></i>
                        <span className="fw-medium">{item.flatName}</span>
                    </div>
                </td>
                <td className="description-cell">
                    {item.flatDescription}
                </td>
                <td className="door-status-cell">
                    <div className="toggle-container">
                        <Toggle 
                            className="modern-toggle"
                            disabled
                            id={`flat-door-${index}`}
                            defaultChecked={item.flatIsDoorOpen}
                        />
                        <span className={`door-status-label ${item.flatIsDoorOpen ? 'open' : 'closed'}`}>
                            <i className={`fas ${item.flatIsDoorOpen ? 'fa-unlock' : 'fa-lock'} me-1`}></i>
                            {item.flatIsDoorOpen ? 'Open' : 'Closed'}
                        </span>
                    </div>
                </td>
                <td className="edit-cell">
                    <div className="btn-group btn-group-sm" role="group">
                        <button
                            className="btn btn-outline-primary btn-sm"
                            onClick={() => this.handleEditEntry(item)}
                            title="Edit flat"
                        >
                            <i className="fas fa-edit me-1"></i>
                            Edit
                        </button>
                        <button
                            className="btn btn-outline-secondary btn-sm"
                            onClick={() => this.handleShowDoorLogs(item)}
                            title="View door activity"
                        >
                            <i className="fas fa-clock-rotate-left me-1"></i>
                            Logs
                        </button>
                    </div>
                </td>
            </tr>
        ));

        return (
            <div className="smart-house-admin-container">
                {!this.state.token ? (
                    <div className="loading-container">
                        <div className="loading-spinner">
                            <i className="fas fa-spinner fa-spin fa-2x text-primary"></i>
                            <p>Loading Smart House Admin...</p>
                        </div>
                    </div>
                ) : (
                    <div className="admin-content">
                        {/* Main Entries Section */}
                        <div className="admin-section">
                            <div className="section-header">
                                <div className="section-title-row">
                                    <h2 className="section-title">
                                        <i className="fas fa-sign-in-alt me-2"></i>
                                        Access Entries
                                    </h2>
                                    <div className="section-actions">
                                        <button
                                            type="button"
                                            className="btn btn-success"
                                            onClick={this.handleAddEntry}
                                        >
                                            <i className="fas fa-plus me-2"></i>
                                            Add New Entry
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Notifications */}
                            {(this.state.isSaved || this.state.isDeleted) && (
                                <div className="notifications">
                                    {this.state.isSaved && (
                                        <div className="alert alert-success-modern" role="alert">
                                            <i className="fas fa-check-circle me-2"></i>
                                            Successfully saved!
                                        </div>
                                    )}
                                    {this.state.isDeleted && (
                                        <div className="alert alert-success-modern" role="alert">
                                            <i className="fas fa-trash-alt me-2"></i>
                                            Successfully deleted!
                                        </div>
                                    )}
                                </div>
                            )}

                            <div className="table-container">
                                <div className="table-responsive">
                                    <table className="table table-modern">
                                        <thead>
                                            <tr>
                                                <th scope="col">
                                                    <i className="fas fa-user me-2"></i>
                                                    For
                                                </th>
                                                <th scope="col">
                                                    <i className="fas fa-building me-2"></i>
                                                    Flat
                                                </th>
                                                <th scope="col">
                                                    <i className="fas fa-sign-in-alt me-2"></i>
                                                    Check In
                                                </th>
                                                <th scope="col">
                                                    <i className="fas fa-sign-out-alt me-2"></i>
                                                    Check Out
                                                </th>
                                                <th scope="col">
                                                    <i className="fas fa-lock me-2"></i>
                                                    Door Code
                                                </th>
                                                <th scope="col">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {displayEntryList}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        {/* Bottom Grid Sections */}
                        <div className="admin-grid">
                            {/* Flats Section */}
                            <div className="admin-section">
                                <div className="section-header">
                                    <h3 className="section-subtitle">
                                        <i className="fas fa-home me-2"></i>
                                        Flat Management
                                    </h3>
                                </div>

                                {(this.state.isUserSaved || this.state.isUserUpdated) && (
                                    <div className="notifications">
                                        {this.state.isUserSaved && (
                                            <div className="alert alert-success-modern" role="alert">
                                                New user added!
                                            </div>
                                        )}
                                        {this.state.isUserUpdated && (
                                            <div className="alert alert-success-modern" role="alert">
                                                User updated!
                                            </div>
                                        )}
                                    </div>
                                )}

                                <div className="table-container">
                                    <div className="table-responsive">
                                        <table className="table table-modern table-compact">
                                            <thead>
                                                <tr>
                                                    <th scope="col">Name</th>
                                                    <th scope="col">Description</th>
                                                    <th scope="col">Door Status</th>
                                                    <th scope="col">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {displayFlatList}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Popups */}
                        <EntryPopup
                            show={this.state.showPopupEntry}
                            popupTitle={this.state.popupTitle}
                            selectedEntry={this.state.selectedEntry}
                            hide={this.handleCloseEntryPopup}
                            token={this.state.token}
                            isDoorCodeValide={true}
                        />

                        <DoorLogPopup
                            show={this.state.showPopupDoorLog}
                            selectedFlat={this.state.selectedFlat}
                            hide={this.handleCloseDoorLogPopup}
                            token={this.state.token}
                        />

                        <ConfirmPopup
                            show={this.state.showConfirmPopup}
                            hide={this.handleConfirmDelete} 
                            title="Delete Entry" 
                            content="Do you really want to delete this entry? This action cannot be undone." 
                        />
                    </div>
                )}
            </div>
        )
    }
}))
